/**
 * Окна правки и удаления сообщения (BS §7.5, `GET /config → limits`).
 *
 * Значения окон приходят с сервера (`edit_window_sec`, `delete_all_window_sec`)
 * и в коде не дублируются. Клиент проверяет их сам, чтобы не предлагать
 * действие, которое сервер заведомо отклонит кодом `edit_window_expired`
 * или `delete_window_expired` (CC §11.2: отказ показывается причиной, а не
 * кодом, и лучше всего — не показывать саму возможность).
 *
 * Это не замена серверной проверки: часы клиента могут отставать, поэтому
 * сервер остаётся источником истины.
 */
import type { Config, Message } from '@shared/api/types'

interface Windowed {
  sender_id: string | null
  created_at: string
  deleted: boolean
  type: Message['type']
}

function withinWindow(createdAt: string, windowSec: number | undefined, now: number): boolean {
  if (!windowSec) return false
  const created = Date.parse(createdAt)
  if (Number.isNaN(created)) return false
  return now - created <= windowSec * 1000
}

/** C-17: править можно только своё текстовое сообщение и только внутри окна. */
export function canEditMessage(
  message: Windowed,
  config: Config | null,
  myUserId: string,
  now: number = Date.now(),
): boolean {
  if (message.sender_id !== myUserId) return false
  if (message.deleted) return false
  if (message.type !== 'text') return false

  return withinWindow(message.created_at, config?.limits.edit_window_sec, now)
}

/** «Удалить у всех» — своё сообщение внутри `delete_all_window_sec`. */
export function canDeleteForAll(
  message: Windowed,
  config: Config | null,
  myUserId: string,
  now: number = Date.now(),
): boolean {
  if (message.sender_id !== myUserId) return false
  if (message.deleted) return false

  return withinWindow(message.created_at, config?.limits.delete_all_window_sec, now)
}
